import _ from "underscore";
import $$ from "squeak";
import keyboardify from "keyboardify";

//\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/
//\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/
//                                                  SQUEAK FLAKES
//\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/

var defaultsettings = {
  logos: [{ name: page.title, url: page.url, }],
  quantity: 15,
  size: [10, 100],
  // text: ["❅", "❆"]
};
var pause = false;

/**
  DESCRIPTION: create a rain of snow flakes that look the way you want them to look
  ARGUMENTS: ({
    ?logos: <string[]|null>@default=[page.title] « if null will not display logo »,
    ?firstLevelLogos: <boolean>@default=false,
    ?text: <string[]>,
    ?quantity: <integer>@default=15,
    ?size: <[integer, integer]>@default=[10, 100],
    ?recursive: <integer>@default=0 « list children recursively, how many time to recurse? »,
  })
  RETURN: <void>
*/
export default function (settings) {
  settings = $$.defaults(defaultsettings, settings);

  // FLAKES CONTAINER
  var $flakes = $app.div({
    class: "snowflakes",
    "aria-hidden": true,
  });

  // SPACEBAR TIP
  $app.div({
    class: "spacebar_tip",
    text: "hit spacebar to disable/enable \"snowflakes\" animation",
  });

  // CREATE SNOWFLAKES
  function start () {
    for (let i = 0; i < settings.quantity; i++) {
      makeSnowFlake($flakes, settings);
    };
  };
  start();

  // PAUSE ON HIT SPACE
  keyboardify.bind("space", function () {
    if (pause) start()
    else $flakes.empty();
    pause = !pause;
  });

};

//\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/
//\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/
//                                                  MAKE SNOWFLAKE
//\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/

function makeSnowFlake ($flakes, settings) {

  // no logos defined
  if (_.isNull(settings.logos)) return;

  // make flake
  var $flake = $flakes.a({ class: "flake snowflake", });

  // flake text
  if (settings.text) $flake.text($$.random.entry(settings.text));

  // flake logo
  var size = $$.random.integer(settings.size) +"px";
  var flakeLogo = $$.random.entry(settings.logos);
  $flake.css({
    width: size,
    height: size,
    left: $$.random.percentage(),
    animationDelay: $$.random.integer(0, 8) +"s,"+ $$.random.number(0, 3) +"s",
    backgroundImage: 'url("/share/logos/'+ flakeLogo.name +'.png")',
  });
  $flake.attr("href", flakeLogo.url);

  setTimeout(function () {
    // fade out
    $flake.fadeOut();
    setTimeout(function () {
      $flake.remove();
      if (!pause) makeSnowFlake($flakes, settings);
    }, 1000);
  }, $$.random.integer(10000, 50000));

};

//\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/
//\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/
